module.exports = __webpack_public_path__ + "static/img/logo@2x.1c4a7a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/logo@2x.png
// module id = Eq8+
// module chunks = 7